var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-form-item",class:{
  'is-error': _vm.validateState === 'error',
  'is-validating': _vm.validateState === 'validating',
  'is-required': _vm.isRequired || _vm.required
}},[(_vm.label)?_c('label',{staticClass:"el-form-item-label",style:(_vm.labelStyle)},[_vm._v("\n          "+_vm._s(_vm.label + _vm.form.labelSuffix)+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"el-form-item-content",style:(_vm.contentStyle)},[_vm._t("default"),_vm._v(" "),_c('transition',{attrs:{"name":"md-fade-bottom"}},[(_vm.validateState === 'error')?_c('div',{staticClass:"el-form-item-error"},[_vm._v(_vm._s(_vm.validateMessage))]):_vm._e()])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f652add","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/src/form-item.vue
// module id = null
// module chunks = 